import { render, staticRenderFns } from "./ad-product-search-sorting.vue?vue&type=template&id=7671e754"
import script from "./ad-product-search-sorting.vue?vue&type=script&lang=ts"
export * from "./ad-product-search-sorting.vue?vue&type=script&lang=ts"
import style0 from "./ad-product-search-sorting.vue?vue&type=style&index=0&id=7671e754&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports